import React, { FC } from "react";  
import { Route, Routes } from "react-router-dom";
import styled from "styled-components";

import Intro from "../Components/Intro";
import Skills from "../Components/Skills";
import ReleaseNote from "../Components/ReleaseNote";

const ContentBox = styled.div`
    width: 100%;
`;


const Tomorrow:FC = () => {
    const content = "tomorrow";
    return (
        <ContentBox>
            <Routes>
                <Route path='/' element={<Intro content={content} />} />
                <Route path='/intro' element={<Intro content={content} />} />
                <Route path='/skills' element={<Skills content={content} />} />
                <Route path='/releasenote' element={<ReleaseNote content={content} />} />
            </Routes>
        </ContentBox>
    );
};

export default Tomorrow